<template>
    <div>
        <div class="row default-padding-top">
            <div class="col-12 col-md-4">
                <strong>Zeitpunkt</strong>
                <br>
                <span v-html="entryTimeString"></span>
            </div>
        </div>

        <template v-if="assignedEmployees">
            <hr>

            <div>
                <div><strong>Zugewiesene Mitarbeiter</strong></div>

                <div class="user-container-list no-padding">
                    <person-box-employee v-for="employee in assignedEmployees" :id="employee" :key="'assigned-employee-' + employee"/>
                </div>
            </div>
        </template>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator';
    import PersonBox from '../../../components/PersonBox.vue';
    import PersonBoxEmployee from '../../../components/PersonBoxEmployee.vue';
    import {getEntryTimeString} from '../../../library/modules/calendar/calendar';

    @Component({
        name: 'ShiftAppointmentViewPopup',
        components: {
            PersonBoxEmployee,
            PersonBox,
        },
    })
    export default class ShiftAppointmentViewPopup extends Vue
    {
        @Prop({
            type: Object,
            required: true,
        }) entry: CalendarEntryData;

        @Prop({
            type: Array,
            required: true,
        }) assignedEmployees: number[];

        get entryTimeString(): string
        {
            return getEntryTimeString(this.entry, false);
        }
    }
</script>